import { iseeInstance } from '../axiosService'

class PatientVUService {
  async fetchPatients (portalName) {
    return iseeInstance.get(`/patients/portal/${portalName}`)
  }

  async addPatient (identifier, displayName, portalName) {
    return iseeInstance.post('/patients', {
      identifier,
      displayName,
      portal: portalName
    })
  }

  async updatePatient (patientId, identifier, displayName, portalName) {
    return iseeInstance.put(`/patients/${patientId}`, {
      identifier,
      displayName,
      portal: portalName
    })
  }

  async deletePatient (patientId) {
    return iseeInstance.delete(`/patients/${patientId}`)
  }

  async linkPatientToSession (patientId, sessionId) {
    return iseeInstance.patch('/patients/link-session', {
      patientId,
      sessionId
    })
  }

  async getPatientById (patientId) {
    return iseeInstance.get(`/patients/${patientId}`)
  }

  async getPatientSessions (patientId) {
    return iseeInstance.get(`/patients/${patientId}/sessions`)
  }
}

export default new PatientVUService()
